module.exports = __webpack_public_path__ + "img/button_next page.efd434dd.png";